import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSelectedFilterKeys } from "@faire/retailer-shared/filters/getFilterOptions";
import { FilterContext } from "@faire/retailer-visitor-shared/components/Filters/FilterContext";
import { FilterState, useCreateFilterStore } from "@faire/retailer-visitor-shared/components/Filters/FilterStore";
import cloneDeep from "lodash/cloneDeep";
import React, { useEffect } from "react";
import { useCategoryPageQueryParams } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { useLoggedOutCategoryPageFilterSections } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageFilterSections";
export var LoggedOutCategoryPageFilterStoreProvider = function(param) {
    var children = param.children;
    var _useLoggedOutCategoryPageFilterSections = useLoggedOutCategoryPageFilterSections(), isFetching = _useLoggedOutCategoryPageFilterSections.isFetching, filterSections = _useLoggedOutCategoryPageFilterSections.data.filterSections;
    var _useCategoryPageQueryParams = useCategoryPageQueryParams(), setFilterKeys = _useCategoryPageQueryParams.setFilterKeys, clearOneIndexedPageNumber = _useCategoryPageQueryParams.clearOneIndexedPageNumber;
    var onFilterSelected = function(state) {
        var filterKeys = getSelectedFilterKeys(state.filterSections);
        setFilterKeys(function() {
            return filterKeys;
        });
        clearOneIndexedPageNumber();
    };
    var filterStore = useCreateFilterStore(FilterState.build({
        isSideBarVisible: false,
        shouldShowFilterCollapsePill: true,
        hideOptionsResultCount: true
    }), onFilterSelected);
    useEffect(function() {
        if (filterSections.length > 0 && !isFetching) {
            filterStore.setState(function(currentState) {
                return _object_spread_props(_object_spread({}, currentState), {
                    filterSections: cloneDeep(filterSections),
                    isNewFilterSelected: false
                });
            });
        }
    }, [
        filterStore,
        isFetching,
        filterSections
    ]);
    return /*#__PURE__*/ _jsx(FilterContext.Provider, {
        value: filterStore,
        children: children
    });
};
